import * as React from 'react';
import clsx from 'clsx';
import { Button, Icon, Typography } from '@/components/common';
import { ModalProps } from '@/hooks/useModal';
import { WelcomeModalHeader } from '@/components/modals/WelcomeModalHeader';
import { WELCOME_STEPS } from '@/const/actionRequired';

interface ActionRequiredWelcomeModalProps {
	Modal: React.FC<ModalProps>;
	hasDocumentAction: boolean;
	onDismiss: () => void;
	onStartVerification: () => void;
}

export const ActionRequiredWelcomeModal: React.FC<
	ActionRequiredWelcomeModalProps
> = ({ Modal, hasDocumentAction, onDismiss, onStartVerification }) => (
	<Modal
		avoidClose
		noMaxHeight
		onClose={onDismiss}
		classNameCardContainer="!p-0 md:!w-[564px]"
		classNameTitle="!mb-0"
		classNameContainerChildren="!px-6 !pt-6"
		classNameFooter=""
		title={
			<WelcomeModalHeader
				title="Welcome Back! Time to Confirm It's You"
				description="Let's confirm your identity and get your claim moving."
				onClose={onDismiss}
			/>
		}
		footer={
			<div className="flex justify-center md:justify-end py-4 bg-white rounded-b-[32px] px-5 border-t border-grey-100">
				<Button
					decoration="primary"
					size="large"
					label="Start Verification"
					className="!h-12 w-full md:w-auto"
					onClick={onStartVerification}
				/>
			</div>
		}
	>
		<Typography
			type="regular-16"
			className="text-center !text-[#4B5563] mb-6 w-full"
		>
			To formally join your case, we need a bit more information from you. We
			use Covalynt&apos;s secure verification service to confirm your identity
			quickly and protect against fraud.
		</Typography>
		<div className="flex flex-col gap-4">
			{(hasDocumentAction ? WELCOME_STEPS : WELCOME_STEPS.slice(0, 1)).map(
				(step) => (
					<div
						key={step.number}
						className="flex gap-4 p-4 border border-gray-5 rounded-xl bg-white"
					>
						<div
							className={clsx(
								'w-10 h-10 shrink-0 rounded-full flex items-center justify-center font-bold text-base',
								step.badgeClassName
							)}
						>
							<Icon src={step.iconSrc} width={18} height={18} />
						</div>
						<div>
							<Typography type="semibold-16" className="!text-left">
								{step.title}
							</Typography>
							<Typography
								type="regular-14"
								className="text-gray-35 mt-1 !text-left"
							>
								{step.description}
							</Typography>
						</div>
					</div>
				)
			)}
		</div>
	</Modal>
);
